import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Bitcoin, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const loc = useLocation();
  if (user) return <Navigate to={loc.state?.from || "/"} replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, pw);
    } catch (e2) {
      setErr(errMsg(e2));
    }
    setBusy(false);
  };
  return (
    <div className="grain min-h-screen bg-[#090A0F] grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex flex-col justify-between p-12 border-r border-zinc-800/80 relative overflow-hidden">
        <div className="absolute inset-0 opacity-25 bg-cover bg-center" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1641580529558-a96cf6efbc72?w=1600&q=70)" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#090A0F] via-[#090A0F]/70 to-transparent" />
        <div className="relative flex items-center gap-3">
          <div className="w-10 h-10 rounded bg-[#F7931A] flex items-center justify-center"><Bitcoin className="w-6 h-6 text-black" /></div>
          <span className="font-display font-bold text-zinc-100 tracking-tight">BTC ZERO DOUBT AI</span>
        </div>
        <div className="relative">
          <h1 className="font-display text-5xl xl:text-6xl font-extrabold tracking-tight text-zinc-50 leading-[1.02]">No trade is better<br />than a <span className="text-[#F7931A]">bad trade.</span></h1>
          <p className="text-zinc-400 mt-6 max-w-md">Eight independent agents. One absolute risk veto. A permanent 10% reserve that the bot can never touch.</p>
          <div className="font-mono text-xs text-zinc-500 mt-10 tracking-[0.2em]">$100 → $1,686,780 · 15 FLIPS · 10% RESERVE · ZERO FORCED ENTRIES</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm panel p-8 fade-up">
          <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500"><Lock className="w-3 h-3" /> Owner access only</div>
          <h2 className="font-display text-2xl font-bold text-zinc-50 mt-3 mb-6">Sign in to the terminal</h2>
          <label className="font-mono text-[10px] uppercase tracking-wider text-zinc-500">Email</label>
          <Input data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 mb-4 bg-[#090A0F]" autoComplete="username" />
          <label className="font-mono text-[10px] uppercase tracking-wider text-zinc-500">Password</label>
          <Input data-testid="login-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5 mb-5 bg-[#090A0F]" autoComplete="current-password" />
          {err && <div data-testid="login-error" className="text-sm text-red-400 mb-4">{err}</div>}
          <Button data-testid="login-submit-button" disabled={busy} className="w-full h-11 bg-[#F7931A] hover:bg-[#E08213] text-black font-semibold">{busy ? "Verifying…" : "Enter terminal"}</Button>
        </form>
      </div>
    </div>
  );
}
